const BusinessQuote = () => import('@/views/modules/business/Quote/Quote')
const BusinessQuoteForm = () => import('@/views/modules/business/Quote/QuoteForm')
const BusinessSaleOrder = () => import('@/views/modules/business/SaleOrder')
const BusinessSaleOrderForm = () => import('@/views/modules/business/SaleOrderForm')
const BusinessInvoice = () => import('@/views/modules/business/Invoice')
const BusinessInvoiceForm = () => import('@/views/modules/business/InvoiceForm')
const BusinessSeller = () => import('@/views/modules/business/Seller')
const BusinessSellerForm = () => import('@/views/modules/business/SellerForm')
const BusinessDeliveryPlan = () => import('@/views/modules/business/DeliveryPlan')
const BusinessDeliveryPlanForm = () => import('@/views/modules/business/DeliveryPlanForm')
const BusinessShippingCompany = () => import('@/views/modules/business/ShippingCompany')
const BusinessShippingCompanyForm = () => import('@/views/modules/business/ShippingCompanyForm')
const BusinessTypeService = () => import('@/views/modules/business/TypeService')
const BusinessTypeServiceForm = () => import('@/views/modules/business/TypeServiceForm')
const BusinessPriceList = () => import('@/views/modules/business/PriceList')
const BusinessPriceListForm = () => import('@/views/modules/business/PriceListForm')
const BusinessPaymentPlan = () => import('@/views/modules/business/PaymentPlan')
const BusinessPaymentPlanForm = () => import('@/views/modules/business/PaymentPlanForm')
const BusinessTypeQuoteStatus = () => import('@/views/modules/business/TypeQuoteStatus')
const BusinessTypeQuoteStatusForm = () => import('@/views/modules/business/TypeQuoteStatusForm')
const BusinessTypeSaleOrderStatus = () => import('@/views/modules/business/TypeSaleOrderStatus')
const BusinessTypeSaleOrderStatusForm = () => import('@/views/modules/business/TypeSaleOrderStatusForm')
const BusinessTypeBudgetRejectionReason = () => import('@/views/modules/business/TypeBudgetRejectionReason')
const BusinessTypeBudgetRejectionReasonForm = () => import('@/views/modules/business/TypeBudgetRejectionReasonForm')
const BusinessSettingParam = () => import('@/views/modules/business/Setting/SettingParam')
const BusinessSettingParamForm = () => import('@/views/modules/business/Setting/SettingParamForm')
const BusinessSetting = () => import('@/views/modules/business/Setting/Setting')
const BusinessReport = () => import('@/views/modules/business/Report')

const PurchaseOrder = () => import('@/views/modules/purchase/PurchaseOrder')
const PurchaseOrderForm = () => import('@/views/modules/purchase/PurchaseOrderForm')
const PurchaseInvoice = () => import('@/views/modules/purchase/PurchaseInvoice')
const PurchaseInvoiceForm = () => import('@/views/modules/purchase/PurchaseInvoiceForm')
const PurchaseSupplier = () => import('@/views/modules/purchase/Supplier')
const PurchaseSupplierForm = () => import('@/views/modules/purchase/SupplierForm')
const PurchaseSettingParam = () => import('@/views/modules/purchase/Setting/SettingParam')
const PurchaseSettingParamForm = () => import('@/views/modules/purchase/Setting/SettingParamForm')
const PurchaseTypeSupplier = () => import('@/views/modules/purchase/TypeSupplier')
const PurchaseTypeSupplierForm = () => import('@/views/modules/purchase/TypeSupplierForm')
const PurchaseSetting = () => import('@/views/modules/purchase/Setting/Setting')
const PurchaseReport = () => import('@/views/modules/purchase/Report')

const FinancialRevenue = () => import('@/views/modules/financial/Revenue')
const FinancialRevenueForm = () => import('@/views/modules/financial/RevenueForm')
const FinancialExpense = () => import('@/views/modules/financial/Expense')
const FinancialExpenseForm = () => import('@/views/modules/financial/ExpenseForm')
const FinancialBankAccount = () => import('@/views/modules/financial/BankAccount')
const FinancialBankAccountForm = () => import('@/views/modules/financial/BankAccountForm')
const FinancialChartAccount = () => import('@/views/modules/financial/ChartAccount')
const FinancialChartAccountForm = () => import('@/views/modules/financial/ChartAccountForm')
const FinancialCreditor = () => import('@/views/modules/financial/Creditor')
const FinancialCreditorForm = () => import('@/views/modules/financial/CreditorForm')
const FinancialSettingParam = () => import('@/views/modules/financial/Setting/SettingParam')
const FinancialSettingParamForm = () => import('@/views/modules/financial/Setting/SettingParamForm')
const FinancialSetting = () => import('@/views/modules/financial/Setting/Setting')
const FinancialReport = () => import('@/views/modules/financial/Report')

const EmployeeEmployee = () => import('@/views/modules/employee/Employee')
const EmployeeEmployeeForm = () => import('@/views/modules/employee/EmployeeForm')
const EmployeeExam = () => import('@/views/modules/employee/Exam')
const EmployeeExamForm = () => import('@/views/modules/employee/ExamForm')
const EmployeeRole = () => import('@/views/modules/employee/Role')
const EmployeeRoleForm = () => import('@/views/modules/employee/RoleForm')
const EmployeeSettingParam = () => import('@/views/modules/employee/Setting/SettingParam')
const EmployeeSettingParamForm = () => import('@/views/modules/employee/Setting/SettingParamForm')
const EmployeeSetting = () => import('@/views/modules/employee/Setting/Setting')
const EmployeeReport = () => import('@/views/modules/employee/Report')

export default [


    {
        path: '/business/quote/new', name: 'business-quote-form-new', component: BusinessQuoteForm
    }, {
        path: '/business/quote/view/:id', name: 'business-quote-form-view', component: BusinessQuoteForm
    }, {
        path: '/business/quote/remove/:id', name: 'business-quote-form-remove', component: BusinessQuoteForm
    }, {
        path: '/business/quote/:id', name: 'business-quote-form', component: BusinessQuoteForm
    }, {path: '/business/quote', name: 'business-quote', component: BusinessQuote}


    , {
        path: '/business/order/new', name: 'business-order-form-new', component: BusinessSaleOrderForm
    }, {
        path: '/business/order/view/:id', name: 'business-order-form-view', component: BusinessSaleOrderForm
    }, {
        path: '/business/order/remove/:id', name: 'business-order-form-remove', component: BusinessSaleOrderForm
    }, {
        path: '/business/order/:id', name: 'business-order-form', component: BusinessSaleOrderForm
    }, {path: '/business/order', name: 'business-order', component: BusinessSaleOrder}


    , {
        path: '/business/invoices/form/',
        alias: '/business/invoices/:id',
        name: 'business-invoices-form',
        component: BusinessInvoiceForm
    }, {path: '/business/invoices', name: 'business-invoices', component: BusinessInvoice}

    , {
        path: '/business/seller/new', name: 'business-seller-form-new', component: BusinessSellerForm
    }, {
        path: '/business/seller/view/:id', name: 'business-seller-form-view', component: BusinessSellerForm
    }, {
        path: '/business/seller/remove/:id', name: 'business-seller-form-remove', component: BusinessSellerForm
    }, {
        path: '/business/seller/:id', name: 'business-seller-form', component: BusinessSellerForm
    }, {path: '/business/seller', name: 'business-seller', component: BusinessSeller}


    , {
        path: '/business/delivery-plan/new',
        name: 'business-delivery-plan-form-new',
        component: BusinessDeliveryPlanForm
    }, {
        path: '/business/delivery-plan/view/:id',
        name: 'business-delivery-plan-form-view',
        component: BusinessDeliveryPlanForm
    }, {
        path: '/business/delivery-plan/remove/:id',
        name: 'business-delivery-plan-form-remove',
        component: BusinessDeliveryPlanForm
    }, {
        path: '/business/delivery-plan/:id', name: 'business-delivery-plan-form', component: BusinessDeliveryPlanForm
    }, {path: '/business/delivery-plan', name: 'business-delivery-plan', component: BusinessDeliveryPlan}


    , {
        path: '/business/shipping-company/new',
        name: 'business-shipping-company-form-new',
        component: BusinessShippingCompanyForm
    }, {
        path: '/business/shipping-company/view/:id',
        name: 'business-shipping-company-form-view',
        component: BusinessShippingCompanyForm
    }, {
        path: '/business/shipping-company/remove/:id',
        name: 'business-shipping-company-form-remove',
        component: BusinessShippingCompanyForm
    }, {
        path: '/business/shipping-company/:id',
        name: 'business-shipping-company-form',
        component: BusinessShippingCompanyForm
    }, {path: '/business/shipping-company', name: 'business-shipping-company', component: BusinessShippingCompany}


    , {
        path: '/business/type-service/new', name: 'business-type-service-form-new', component: BusinessTypeServiceForm
    }, {
        path: '/business/type-service/view/:id',
        name: 'business-type-service-form-view',
        component: BusinessTypeServiceForm
    }, {
        path: '/business/type-service/remove/:id',
        name: 'business-type-service-form-remove',
        component: BusinessTypeServiceForm
    }, {
        path: '/business/type-service/:id', name: 'business-type-service-form', component: BusinessTypeServiceForm
    }, {path: '/business/type-service', name: 'business-type-service', component: BusinessTypeService}


    , {
        path: '/business/price-list/new', name: 'business-price-list-form-new', component: BusinessPriceListForm
    }, {
        path: '/business/price-list/view/:id', name: 'business-price-list-form-view', component: BusinessPriceListForm
    }, {
        path: '/business/price-list/remove/:id',
        name: 'business-price-list-form-remove',
        component: BusinessPriceListForm
    }, {
        path: '/business/price-list/:id', name: 'business-price-list-form', component: BusinessPriceListForm
    }, {path: '/business/price-list', name: 'business-price-list', component: BusinessPriceList}

    , {
        path: '/business/type-quote-status/new',
        name: 'business-type-quote-status-form-new',
        component: BusinessTypeQuoteStatusForm
    }, {
        path: '/business/type-quote-status/view/:id',
        name: 'business-type-quote-status-form-view',
        component: BusinessTypeQuoteStatusForm
    }, {
        path: '/business/type-quote-status/remove/:id',
        name: 'business-type-quote-status-form-remove',
        component: BusinessTypeQuoteStatusForm
    }, {
        path: '/business/type-quote-status/:id',
        name: 'business-type-quote-status-form',
        component: BusinessTypeQuoteStatusForm
    }, {path: '/business/type-quote-status', name: 'business-type-quote-status', component: BusinessTypeQuoteStatus}

    , {
        path: '/business/type-order-status/new',
        name: 'business-type-order-status-form-new',
        component: BusinessTypeSaleOrderStatusForm
    }, {
        path: '/business/type-order-status/view/:id',
        name: 'business-type-order-status-form-view',
        component: BusinessTypeSaleOrderStatusForm
    }, {
        path: '/business/type-order-status/remove/:id',
        name: 'business-type-order-status-form-remove',
        component: BusinessTypeSaleOrderStatusForm
    }, {
        path: '/business/type-order-status/:id',
        name: 'business-type-order-status-form',
        component: BusinessTypeSaleOrderStatusForm
    }, {path: '/business/type-order-status', name: 'business-type-order-status', component: BusinessTypeSaleOrderStatus}

    , {
        path: '/business/type-budget-rejection-reason/new',
        name: 'business-type-budget-rejection-reason-form-new',
        component: BusinessTypeBudgetRejectionReasonForm
    }, {
        path: '/business/type-budget-rejection-reason/view/:id',
        name: 'business-type-budget-rejection-reason-form-view',
        component: BusinessTypeBudgetRejectionReasonForm
    }, {
        path: '/business/type-budget-rejection-reason/remove/:id',
        name: 'business-type-budget-rejection-reason-form-remove',
        component: BusinessTypeBudgetRejectionReasonForm
    }, {
        path: '/business/type-budget-rejection-reason/:id',
        name: 'business-type-budget-rejection-reason-form',
        component: BusinessTypeBudgetRejectionReasonForm
    }
    , {path: '/business/type-budget-rejection-reason', name: 'business-type-budget-rejection-reason', component: BusinessTypeBudgetRejectionReason}

    , {
        path: '/business/payment-plan/new', name: 'business-payment-plan-form-new', component: BusinessPaymentPlanForm
    }, {
        path: '/business/payment-plan/view/:id',
        name: 'business-payment-plan-form-view',
        component: BusinessPaymentPlanForm
    }, {
        path: '/business/payment-plan/remove/:id',
        name: 'business-payment-plan-form-remove',
        component: BusinessPaymentPlanForm
    }, {
        path: '/business/payment-plan/:id', name: 'business-payment-plan-form', component: BusinessPaymentPlanForm
    }, {path: '/business/payment-plan', name: 'business-payment-plan', component: BusinessPaymentPlan}

    , {
        path: '/business/setting/param/view/:id',
        name: 'business-setting-param-form-view',
        component: BusinessSettingParamForm
    }, {
        path: '/business/setting/param/:id', name: 'business-setting-param-form-', component: BusinessSettingParamForm
    }

    , {path: '/business/setting/param', name: 'business-setting-param', component: BusinessSettingParam}


    , {path: '/business/setting', name: 'business-setting', component: BusinessSetting}

    , {path: '/business/report', name: 'business-report', component: BusinessReport}


    , {
        path: '/purchase/order/new', name: 'purchase-order-form-new', component: PurchaseOrderForm
    }, {
        path: '/purchase/order/view/:id', name: 'purchase-order-form-view', component: PurchaseOrderForm
    }, {
        path: '/purchase/order/remove/:id', name: 'purchase-order-form-remove', component: PurchaseOrderForm
    }, {
        path: '/purchase/order/:id', name: 'purchase-order-form', component: PurchaseOrderForm
    }, {path: '/purchase/order', name: 'purchase-order', component: PurchaseOrder} ,

    {
        path: '/purchase/invoice/new', name: 'purchase-invoice-form-new', component: PurchaseInvoiceForm
    }, {
        path: '/purchase/invoice/view/:id', name: 'purchase-invoice-form-view', component: PurchaseInvoiceForm
    }, {
        path: '/purchase/invoice/remove/:id', name: 'purchase-invoice-form-remove', component: PurchaseInvoiceForm
    }, {
        path: '/purchase/invoice/:id', name: 'purchase-invoice-form', component: PurchaseInvoiceForm
    }, {path: '/purchase/invoice', name: 'purchase-invoice', component: PurchaseInvoice}

    , {
        path: '/purchase/type-supplier/new',
        name: 'purchase-type-supplier-form-new',
        component: PurchaseTypeSupplierForm
    }, {
        path: '/purchase/type-supplier/view/:id',
        name: 'purchase-type-supplier-form-view',
        component: PurchaseTypeSupplierForm
    }, {
        path: '/purchase/type-supplier/remove/:id',
        name: 'purchase-type-supplier-form-remove',
        component: PurchaseTypeSupplierForm
    }, {
        path: '/purchase/type-supplier/:id', name: 'purchase-type-supplier-form', component: PurchaseTypeSupplierForm
    }, {path: '/purchase/type-supplier', name: 'purchase-type-supplier', component: PurchaseTypeSupplier}

    , {
        path: '/purchase/supplier/new', name: 'purchase-supplier-form-new', component: PurchaseSupplierForm
    }, {
        path: '/purchase/supplier/view/:id', name: 'purchase-supplier-form-view', component: PurchaseSupplierForm
    }, {
        path: '/purchase/supplier/remove/:id', name: 'purchase-supplier-form-remove', component: PurchaseSupplierForm
    }, {
        path: '/purchase/supplier/:id', name: 'purchase-supplier-form', component: PurchaseSupplierForm
    }, {path: '/purchase/supplier', name: 'purchase-supplier', component: PurchaseSupplier}


    , {
        path: '/purchase/setting/param/view/:id',
        name: 'purchase-setting-param-form-view',
        component: PurchaseSettingParamForm
    }, {
        path: '/purchase/setting/param/:id', name: 'purchase-setting-param-form-', component: PurchaseSettingParamForm
    }

    , {path: '/purchase/setting/param', name: 'purchase-setting-param', component: PurchaseSettingParam}

    , {path: '/purchase/setting', name: 'purchase-setting', component: PurchaseSetting}

    , {path: '/purchase/report', name: 'purchase-report', component: PurchaseReport}

    , {
        path: '/financial/chart-account/new',
        name: 'financial-chart-account-form-new',
        component: FinancialChartAccountForm
    }, {
        path: '/financial/chart-account/view/:id',
        name: 'financial-chart-account-form-view',
        component: FinancialChartAccountForm
    }, {
        path: '/financial/chart-account/remove/:id',
        name: 'financial-chart-account-form-remove',
        component: FinancialChartAccountForm
    }, {
        path: '/financial/chart-account/:id', name: 'financial-chart-account-form', component: FinancialChartAccountForm
    }, {path: '/financial/chart-account', name: 'financial-chart-account', component: FinancialChartAccount},

    {
        path: '/financial/expense/new', name: 'financial-expense-form-new', component: FinancialExpenseForm
    }, {
        path: '/financial/expense/view/:id', name: 'financial-expense-form-view', component: FinancialExpenseForm
    }, {
        path: '/financial/expense/remove/:id', name: 'financial-expense-form-remove', component: FinancialExpenseForm
    }, {
        path: '/financial/expense/:id', name: 'financial-expense-form', component: FinancialExpenseForm
    }, {path: '/financial/expense', name: 'financial-expense', component: FinancialExpense}


    , {
        path: '/financial/revenue/new', name: 'financial-revenue-form-new', component: FinancialRevenueForm
    }, {
        path: '/financial/revenue/view/:id', name: 'financial-revenue-form-view', component: FinancialRevenueForm
    }, {
        path: '/financial/revenue/remove/:id', name: 'financial-revenue-form-remove', component: FinancialRevenueForm
    }, {
        path: '/financial/revenue/:id', name: 'financial-revenue-form', component: FinancialRevenueForm
    }, {path: '/financial/revenue', name: 'financial-revenue', component: FinancialRevenue}


    , {
        path: '/financial/bank-account/new',
        name: 'financial-bank-account-form-new',
        component: FinancialBankAccountForm
    }, {
        path: '/financial/bank-account/view/:id',
        name: 'financial-bank-account-form-view',
        component: FinancialBankAccountForm
    }, {
        path: '/financial/bank-account/remove/:id',
        name: 'financial-bank-account-form-remove',
        component: FinancialBankAccountForm
    }, {
        path: '/financial/bank-account/:id', name: 'financial-bank-account-form', component: FinancialBankAccountForm
    }, {path: 'financial/bank-account', name: 'financial-bank-account', component: FinancialBankAccount}

    , {
        path: '/financial/creditor/new', name: 'financial-creditor-form-new', component: FinancialCreditorForm
    }, {
        path: '/financial/creditor/view/:id', name: 'financial-creditor-form-view', component: FinancialCreditorForm
    }, {
        path: '/financial/creditor/remove/:id', name: 'financial-creditor-form-remove', component: FinancialCreditorForm
    }, {
        path: '/financial/creditor/:id', name: 'financial-creditor-form', component: FinancialCreditorForm
    }, {path: '/financial/creditor', name: 'financial-creditor', component: FinancialCreditor}

    , {
        path: '/financial/setting/param/view/:id',
        name: 'financial-setting-param-form-view',
        component: FinancialSettingParamForm
    }, {
        path: '/financial/setting/param/:id',
        name: 'financial-setting-param-form-',
        component: FinancialSettingParamForm
    }

    , {path: '/financial/setting/param', name: 'financial-setting-param', component: FinancialSettingParam}

    , {path: '/financial/setting', name: 'financial-setting', component: FinancialSetting}

    , {path: '/financial/report', name: 'financial-report', component: FinancialReport}


    , {
        path: '/employee/role/new', name: 'employee-role-form-new', component: EmployeeRoleForm
    }, {
        path: '/employee/role/view/:id', name: 'employee-role-form-view', component: EmployeeRoleForm
    }, {
        path: '/employee/role/remove/:id', name: 'employee-role-form-remove', component: EmployeeRoleForm
    }, {
        path: '/employee/role/:id', name: 'employee-role-form', component: EmployeeRoleForm
    }, {path: '/employee/role', name: 'employee-role', component: EmployeeRole}


    , {
        path: '/employee/exam/new', name: 'employee-exam-form-new', component: EmployeeExamForm
    }, {
        path: '/employee/exam/view/:id', name: 'employee-exam-form-view', component: EmployeeExamForm
    }, {
        path: '/employee/exam/remove/:id', name: 'employee-exam-form-remove', component: EmployeeExamForm
    }, {
        path: '/employee/exam/:id', name: 'employee-exam-form', component: EmployeeExamForm
    }, {path: '/employee/exam', name: 'employee-exam', component: EmployeeExam}, {
        path: '/employee/setting/param/view/:id',
        name: 'employee-setting-param-form-view',
        component: EmployeeSettingParamForm
    }, {
        path: '/employee/setting/param/:id', name: 'employee-setting-param-form-', component: EmployeeSettingParamForm
    }, {path: '/employee/setting/param', name: 'employee-setting-param', component: EmployeeSettingParam}

    , {path: '/employee/setting', name: 'employee-setting', component: EmployeeSetting}

    , {path: '/employee/report', name: 'employee-report', component: EmployeeReport}

    /*Path curto sempre no final do módulo*/, {
        path: '/employee/new', name: 'employee-record-form-new', component: EmployeeEmployeeForm
    }, {
        path: '/employee/view/:id', name: 'employee-record-form-view', component: EmployeeEmployeeForm
    }, {
        path: '/employee/remove/:id', name: 'employee-record-form-remove', component: EmployeeEmployeeForm
    }, {
        path: '/employee/:id', name: 'employee-record-form', component: EmployeeEmployeeForm
    }, {path: '/employee', name: 'employee-record', component: EmployeeEmployee}

]